export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/activity_search.worker-3a31c2ec325304207577.worker.js");
}
